import { useCallback } from "react";

import { BrandingSettings } from "agavepulse/settings/BrandingSettings";
import type { DashboardBranding } from "agavepulse/theme/branding-types";
import { setDashboardAttributes } from "metabase/dashboard/actions";
import { updateDashboard } from "metabase/dashboard/actions/save";
import { useDispatch } from "metabase/redux";
import type { Dashboard } from "metabase-types/api";

/**
 * Connects the branding editor to the dashboard.
 *
 * Saves immediately rather than waiting for a "Save" button, matching the Auto-apply
 * filters toggle in this same sidesheet: set the attribute locally so the preview and the
 * dashboard behind the sidesheet update at once, then persist just that one field.
 * `updateDashboard` picks only the named attributes, so this cannot clobber a concurrent
 * edit to dashcards or tabs.
 */
export function DashboardBrandingSection({
  dashboard,
  disabled,
}: {
  dashboard: Dashboard;
  disabled?: boolean;
}) {
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (branding: DashboardBranding | null) => {
      dispatch(
        setDashboardAttributes({
          id: dashboard.id,
          attributes: { branding },
        }),
      );
      dispatch(updateDashboard({ attributeNames: ["branding"] }));
    },
    [dashboard.id, dispatch],
  );

  return (
    <BrandingSettings
      branding={dashboard.branding}
      disabled={disabled}
      onChange={handleChange}
    />
  );
}
